import React from 'react';
import cx from 'classnames';

import styles from './styles.module.scss';

let Button = ({
  onClick,
  children,
  disabled,
  color, // blue, green, darkBlue, orangeGradient, lightBlue, lightGrey
  size, // small, medium, large
  className,
  icon,
  opaque = true, // boolean
  circle = false, // boolean
  loading = false, // bolean
  ...props
}) => (
  <button
    onClick={disabled ? () => {} : onClick}
    className={cx(
      styles.container,
      styles[size],
      styles[color],
      { [styles.disabled]: disabled },
      { [styles.opaque]: opaque },
      { [styles.circle]: circle },
      { [styles.loading]: loading },
      className
    )}
    {...props}>
    {icon && <i className={cx('material-icons', styles.icon)}>{icon}</i>}
    {children}
  </button>
);

Button.Text = ({
  onClick,
  children,
  size, // small, medium, large
  icon,
  className
}) => (
  <div
    onClick={onClick}
    className={cx(styles.buttonText, styles[size], className)}>
    {icon && <i className={cx('material-icons', styles.icon)}>{icon}</i>}
    {children}
  </div>
);

export default Button;
